/**
 * COUNTERPARTY backend error-code mappings.
 *
 * Maps `error_code` values returned by the counterparty create/update endpoints
 * to user-facing, localized messages so the frontend owns the wording (and its
 * translation) rather than displaying the raw backend `message`.
 */

/**
 * Map: error_code -> localized messages.
 */
export const COUNTERPARTY_ERROR_MESSAGES_BY_CODE = {
  INVALID_SIREN: {
    en: 'The SIREN number is not valid.',
    fr: "Le numéro SIREN saisi n'est pas valide.",
  },
};

export function isCounterpartyApi(api) {
  return typeof api === 'string' && api.includes('counterparty');
}

/**
 * Resolve a user-facing message for a counterparty backend error payload.
 * Returns null for unmapped codes so the caller can fall back to its default.
 */
export function resolveCounterpartyErrorMessage({error, locale = 'fr'} = {}) {
  const code = error?.error_code || error?.code || error?.errorCode;
  if (!code) return null;
  const normalizedLocale = locale === 'en' ? 'en' : 'fr';
  const perCode = COUNTERPARTY_ERROR_MESSAGES_BY_CODE[code];
  return perCode?.[normalizedLocale] || null;
}
